__webpack_require__.p = "/shoppingCard/";